<template id="app-side-bar">
  <div class="vertical-menu">
    <div class="h-100">
      <div class="user-wid text-center py-4">
        <app-avatar-admin :name="$store.state.users.name" :admin="$store.state.users.isAdmin"
          extra-classes="avatar-md centered avatar-bordered" />

        <div class="mt-3">
          <a href="#" class="text-body fw-medium font-size-16">{{ $store.state.users.name }}</a>
        </div>
      </div>
      <!--- Sidemenu -->
      <div id="sidebar-menu">
        <!-- Left Menu Start -->
        <ul class="metismenu list-unstyled" id="side-menu">
          <li class="menu-title mt-3">Menu</li>
          <li>
            <router-link exact-active-class="active" to="/s/dashboard">
              <i class="mdi mdi-airplay"></i>
              <span>Dashboard</span>
            </router-link>
          </li>
          <template v-if="boards.total > 0">
            <li :class="[{ 'mm-active': state == 1 }, {'active': cssBoard}]">
              <a class="has-arrow waves-effect" @click="state = 1" :class="{'active': cssBoard}">
                <i class="mdi mdi-calendar-check"></i>
                <span>Boards</span>
              </a>
              <ul class="sub-menu show">
                
                <li v-for="(board, index) in boards.data" v-bind:key="index">
                  <router-link exact-active-class="active"
                    :to="'/s/board/' + board.team_id + '/' + board.id + '/' + board.alias + '/board'">{{ board.name | limited(20) }}</router-link>
                </li>
              </ul>
            </li>
          </template>

          <li v-if="$store.state.users.id === 114" :class="{ 'mm-active': state == 2 }">
            <a class="has-arrow waves-effect" @click="state = 2">
              <i class="mdi mdi-settings-transfer-outline"></i>
              <span>Configurações</span>
            </a>
            <ul class="sub-menu">
              <li>
                <router-link exact-active-class="active" to="/a/users">Usuários</router-link>
              </li>
              <li>
                <router-link exact-active-class="active" to="/a/squads">Grupos</router-link>
              </li>
              <li>
                <router-link exact-active-class="active" to="/a/properties">Propriedades</router-link>
              </li>
              <li>
                <router-link exact-active-class="active" to="/a/all-boards">Boards</router-link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <!-- Sidebar -->
    </div>
  </div>
</template>
<script>
import AppAvatarAdmin from "@/components/AppAvatarAdmin/AppAvatarAdmin";
export default {
  props: {
    boards: {
      type: [Object, Array]
    }
  },
  components: {
    AppAvatarAdmin
  },
  data() {
    return {
      state: false,
      cssBoard: false
    };
  },
  beforeDestroy() {
    document.removeEventListener("click", this.close);
  },
  mounted() {
    if(this.$route.params.team){
      this.cssBoard = true;
    }
  },
  methods: {
    toggleDropdown(e) {
      this.state = !this.state;
    },
    close(e) {
      if (!this.$el.contains(e.target)) {
        this.state = false;
      }
    }
  },
};
</script>
<style scoped>
.sub-menu {
  height: 0px;
  overflow: hidden;

}

.mm-active>.sub-menu {
  height: auto;
  -webkit-transition: all 2s;
  transition: all 2s;
}

.h-100 {
  min-height: 100vh;
}
</style>
